module.exports = __webpack_public_path__ + "img/Placeholder.8b00f9d3.png";